const genres = [
  'ドラマ','恋愛','アニメ','戦争','音楽','ミュージカル', 'スポーツ', 'SF', '青春', 'コメディ',
  'アクション', 'アドベンチャー', 'ファンタジー', 'ファミリー', 'ドキュメンタリー', '時代劇', '西部劇',
  'ミステリー', 'サスペンス', 'パニック', 'スリラー', 'ホラー', 'ヤクザ・任侠', 'ギャング・マフィア',
  'バイオレンス', '歴史', 'オムニバス', 'アート', '特撮', '学園', 'ヒーロー', 'ギャンブル', '犯罪',
  '伝記', '官能', '舞台・演劇', 'キッズ', '自然'
]
export const favoriteGenres = genres.map(str => ({
  name: str,
  id: str
}))